module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d98fb626fea4e6b0e57dd69cd5def2f0.png";